export const SIGNIN_REDIRECT_URL = 'signin-redirectUrl';
export const SHIPPO_ONBOARD_STATE = 'shippo-onboard-state';
export const SHIPPO_REDIRECT_TO_PROFILE_PAGE_STATE = 'shippo-redirect-to-profile-state';
export const REDIRECT_TO_SELLER_APPLICATION = 'redirect-to-seller-application';
export const DISPLAY_UPDATE_PHONE_NUMBER = 'display-phone-number-update-modal';
